import { useQuery } from 'react-query'
import { getCohorts, getNetworkCohorts } from '../Reports/apis/api-reports'
import { useTeam } from '../Context/TeamContext'

export const useCohorts = () => {
    const { courseID: courseId, networkId } = useTeam()

    // Detect if we're in Network context (unified reports)
    // Only true for /network/{id}/reports, NOT for /network/{id}/cohorts/{cohortId}/reports
    const isNetworkContext = !!networkId && window.location.pathname.startsWith(`/network/${networkId}/reports`)
    // Network cohorts query
    const { data: networkCohortsData, ...networkQueryRest } = useQuery(
        [networkId, 'Network Reports', 'Cohorts'],
        () => getNetworkCohorts(networkId),
        {
            enabled: isNetworkContext && !!networkId,
            staleTime: 1000 * 60 * 5,
            retry: 3,
        }
    )

    // Course cohorts query
    const { data: cohortsData, ...courseQueryRest } = useQuery(
        [courseId, 'Reports', 'Cohorts'],
        () => getCohorts(courseId),
        {
            enabled: !isNetworkContext && !!courseId,
            staleTime: 1000 * 60 * 5,
            retry: 3,
        }
    )

    // For network context, transform cohort objects to array of startDates for backwards compatibility
    // Normalize dates to YYYY-MM-DD format for consistency with selected dates
    const cohorts = isNetworkContext
        ? networkCohortsData?.cohorts
              ?.map((c) => c.startDate.substring(0, 10)) // Extract only YYYY-MM-DD
              .filter((date): date is string => !!date) || []
        : cohortsData?.cohorts || []

    // Store original cohort data for Network context (needed for getting courseIds)
    // Filter out cohorts without valid courseIdMongo
    const networkCohorts = isNetworkContext ? networkCohortsData?.cohorts?.filter((c) => !!c.courseIdMongo) || [] : null

    const { lastMigrationDate } = cohortsData || networkCohortsData || {}

    // Return the appropriate query rest properties based on context
    const queryRest = isNetworkContext ? networkQueryRest : courseQueryRest

    return {
        cohorts,
        networkCohorts, // Original cohort objects with courseId
        lastMigrationDate,
        ...queryRest,
    }
}
